import { convertCase } from '@/utils';
import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker.worker_monthly_attendance.';
export const workerMonthlyAttendanceSearchType = {
    // 라이더명
    WORKER_NAME: 'WORKER_NAME',
    // 사번
    HUB_EMPLOYEE_NUMBER: 'HUB_EMPLOYEE_NUMBER',
};
const workerMonthlyAttendanceUseYnTypeList = [
    workerMonthlyAttendanceSearchType.WORKER_NAME,
    workerMonthlyAttendanceSearchType.HUB_EMPLOYEE_NUMBER,
];
const workerMonthlyAttendanceSearchTypeOptionList = workerMonthlyAttendanceUseYnTypeList
    .map((value) => {
    const text = convertCase(value, 'enum', 'snake');
    return {
        text: t(lc + text),
        value,
    };
});
export { workerMonthlyAttendanceSearchTypeOptionList };
